//      
import React, { useState, Component } from 'react';
import { Redirect } from 'react-router-dom';
import { isUndefined } from 'lodash';

import { post } from 'api';
import { Alert, Button } from 'bs';
import { useMount } from 'utils/hooks';
import { stripLocalHostname } from 'utils/urls';
import PageSpinner from 'components/PageSpinner';

import { CenterBox } from './utils';
import RegistrationSent from './RegistrationSent';

              
               
                  
                          
  

const ResendRegistration = ({ id }) => {
    const [status, setStatus] = useState('');

    useMount(() => {
        post(`registration/customer/register/${id}/`)
            .then(resp => {
                setStatus('success');
            })
            .catch(e => {
                setStatus('error');
            });
    });

    if (status === 'error') {
        return (
            <Alert flavor='warning'>We could not send a new registration link.</Alert>
        );
    } else if (status === 'success') {
        return <RegistrationSent />;
    } else {
        return <PageSpinner />;
    }
};

function confirmRegistration(id, token, callbacks) {
    callbacks.start();
    post(`registration/customer/${id}/${token}/`)
        .then(resp => {
            callbacks.done(resp);
        })
        .catch(e => callbacks.fail(e));
}

class ConfirmRegistration extends Component        {
    state = {
        validToken: undefined,
        resend: false,
        redirect: '/',
    };

    componentDidMount() {
        const { id, token, onSuccess } = this.props;
        const callbacks = {
            start: () => {},
            done: resp => {
                onSuccess && onSuccess();
                this.setState({
                    validToken: true,
                    redirect: stripLocalHostname(resp.redirect || '/'),
                });
            },
            fail: () => this.setState({ validToken: false }),
        };
        confirmRegistration(id, token, callbacks);
    }

    render() {
        const { id } = this.props;
        const { redirect, resend, validToken } = this.state;

        const setResend = () => this.setState({ resend: true });

        if (isUndefined(validToken)) {
            return <PageSpinner />;
        }

        if (validToken) {
            return <Redirect to={redirect} />;
        }

        if (!validToken) {
            return (
                <CenterBox>
                    {resend ? (
                        <div>
                            <ResendRegistration id={id} />
                        </div>
                    ) : (
                        <div>
                            <h2>This single-use token has expired.</h2>
                            <Button onClick={setResend}>
                                Resend confirmation link
                            </Button>
                        </div>
                    )}
                </CenterBox>
            );
        }
    }
}

export default ConfirmRegistration;
